import {useSessionStorage} from '@aboutyou/storage';
import {useNotifications} from '../../useNotifications';

export const useHasNewNotification = () => {
  const {notificationsData, fetchNotifications} = useNotifications();
  const notifications = notificationsData?.notifications ?? [];

  const [wasNotificationCenterOpened, setWasNotificationCenterOpened] =
    useSessionStorage({
      key: 'was_notification_center_opened',
      defaultValue: false,
    });

  const notificationsCount = wasNotificationCenterOpened
    ? 0
    : notifications.length;

  return {
    notificationsCount,
    setWasNotificationCenterOpened,
    fetchNotifications,
  };
};
